const bool2str = b => b ? 'true' : 'false';

const setAttributes = (el, attr) =>
    Object.keys(attr).forEach(k => {
        const v = attr[k];
        if (v === null)
            el.removeAttribute(k);
        else
            el.setAttribute(k, v);
    });

const KeyCode = {
    CANCEL: 3,
    HELP: 6,
    BACK_SPACE: 8,
    TAB: 9,
    CLEAR: 12,
    RETURN: 13,
    ENTER: 14,
    SHIFT: 16,
    CONTROL: 17,
    ALT: 18,
    PAUSE: 19,
    CAPS_LOCK: 20,
    ESCAPE: 27,
    SPACE: 32,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    END: 35,
    HOME: 36,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    PRINTSCREEN: 44,
    INSERT: 45,
    DELETE: 46,
};

const componentId = () => Math.random().toString(32).slice(2, 12);

function debounce(func, wait, immediate) {
    let timeout;
    return function() {
        const context = this, args = arguments;
        const later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

const MediaQuery = {
    smallUpViewport: '(min-width: 480px)',
    mediumUpViewport: '(min-width: 768px)',
    largeUpViewport: '(min-width: 1024px)',
    xlargeUpViewport: '(min-width: 1280px)',
    xxlargeUpViewport: '(min-width: 1340px)',
    navViewport: '(min-width: 1180px)',
    navMobileViewport: '(max-width: 1179px)',
};

const revealElements = (base, f) => {
    [
        { name: '.reveal', options: {} },
        { name: '.reveal--big', options: { viewFactor: 0.1 } },
        { name: '.reveal--huge', options: { viewFactor: 0.06 } },
    ].forEach(({ name, options }) => {
        base.querySelectorAll(name).length > 0 && window.sr.reveal(name, options);
        if (f === true) {
            const first = base.querySelector(name);
            first !== null && window.sr.reveal(first);
        }
    });
};

const decorate = (fn, cb) => {
    const o = fn;
    return () => { cb(); o(); };
};

export {
    bool2str,
    componentId,
    debounce,
    decorate,
    setAttributes,
    KeyCode,
    MediaQuery,
    revealElements,
};
